import { memo } from 'react';
import AreaForm from './AreaForm';
import DpeForm from './DpeForm';
import styles from './adDetailsForms.module.scss';
import { useAppSelector } from '../../../../../../App/redux/store';
import TabContainer from '../../../../../../components/Assets/TabContainer';
import { getSelectedAdDetailsFormTabState } from '../../../../../../store/appManager/reducer';

function AdDetailsForms({ ad }: { ad: Ad }) {
  const selectedAdDetailsFormTab = useAppSelector(getSelectedAdDetailsFormTabState);
  const adDetailsTabsArray = [
    { index: 0, name: 'Parcelle' },
    { index: 1, name: 'DPE' },
  ];

  if (!ad) return null;

  return (
    <section className={styles.adDetailsFormContainer}>
      <h3 className="ad-details-section-title">
        Recherche automatique de l&#039;emplacement du bien
      </h3>

      <div className={styles.tabContainer}>
        <TabContainer tabArray={adDetailsTabsArray} type="adDetailsForms" />
        <div className={styles.formContainer}>
          {selectedAdDetailsFormTab === 0 && <AreaForm ad={ad} />}
          {selectedAdDetailsFormTab === 1 && <DpeForm ad={ad} />}
        </div>
      </div>
    </section>
  );
}

export default memo(AdDetailsForms);
